module.exports = __webpack_public_path__ + "static/media/people_hug.eb12007b.jpg";